import { Box, Button, Divider, FormControlLabel, Popover, Radio, RadioGroup, Stack, Typography, colors } from '@mui/material';
import { decode } from 'jsonwebtoken';
import React from 'react';
import { toast } from 'react-hot-toast';
import Cookies from 'universal-cookie';
import { isFunctionEligible } from '../helpers/eligibilityChecker';
import _ from 'lodash';
import { LoadingButton } from '@mui/lab';
import { fetchWith401Check } from '../helpers/http';
import PreviewIcon from '@mui/icons-material/ArrowForward';
import moment from 'moment/moment';
import DialogQuestions from './DialogQuestions';
const TrackChanges = ({ repository, userInfo }) => {
  const [trackChanges, setTrackChanges] = React.useState([]);
  const [loadingState, setLoadingState] = React.useState({ update: false });
  const [dialogState, setDialogState] = React.useState({});

  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const cookies = new Cookies();
  const decoded = decode(cookies.get('token'));

  const getTrackChanges = () => {
    if (!repository.id) return;
    setLoadingState({ ...loadingState, trackchanges: true });
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
    };
    fetchWith401Check(`${API_URL}/tabledatas/trackchanges/${repository.id}`, requestOptions)
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        if (response?.status == 200) {
          setTrackChanges(response?.response);
        }
      })
      .catch(function (err) {
        return toast.error(err.message);
      })
      .finally(function () {
        setLoadingState({ ...loadingState, trackchanges: false });
      });
  };

  React.useEffect(() => {
    getTrackChanges(repository.id);
  }, [repository.id]);

  return (
    <Stack direction='column'>
      <Stack direction='column' alignItems='flex-start' sx={{ width: '100%' }} spacing={2} py={2}>
        <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
          Perubahan / <i>Track Changes</i>
        </Typography>
        <Stack direction='column' spacing={2} sx={{ width: '100%' }}>
          {trackChanges.map((track) => (
            <Stack direction='column' spacing={1} index={track.id}>
              <Typography variant='body2' sx={{ fontStyle: 'italic' }}>
                {moment(track?.createdAt).format('YYYY-MM-DD, HH:mm:ss')} ({track.type})
              </Typography>
              <Typography variant='body2'>
                {track?.User?.username} ({track?.User?.type})
              </Typography>
              <Stack
                direction='row'
                alignItems='center'
                sx={{ cursor: 'pointer' }}
                onClick={() => setDialogState({ ...dialogState, detail: true, metadata: track })}
              >
                <PreviewIcon fontSize='small' />
                <Typography sx={{ fontWeight: 'bold' }} color='primary' variant='caption'>
                  Preview track changes
                </Typography>
              </Stack>

              <Divider sx={{ width: '100%' }} />
            </Stack>
          ))}
          <Typography variant='body2'></Typography>
        </Stack>
      </Stack>
      {!_.isEmpty(dialogState.metadata) && (
        <DialogQuestions
          userInfo={userInfo}
          metadata={dialogState.metadata}
          open={dialogState.detail}
          handleClose={() => {
            // setDialogState({ ...dialogState, detail: false });
            window.location.reload();
          }}
        />
      )}
    </Stack>
  );
};

export default TrackChanges;
